import { render, staticRenderFns } from "./CustomerBox.vue?vue&type=template&id=1621edff&scoped=true&"
import script from "./CustomerBox.vue?vue&type=script&lang=js&"
export * from "./CustomerBox.vue?vue&type=script&lang=js&"
import style0 from "../style/customer-box.scss?vue&type=style&index=0&id=1621edff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1621edff",
  null
  
)

export default component.exports